module.exports = __webpack_public_path__ + "static/media/free.5ea0fb03.svg";